// extracted by mini-css-extract-plugin
export default {"search_field":"styles_search_field__vJy7D","search_icon":"styles_search_icon__+cX5Y","search_area":"styles_search_area__g5R6y"};